import { useLocation } from "react-router-dom";
import "./WhatsappWidget.scss";
const WhatsappWidget = () => {
  const location = useLocation();
  return (
    <>
      {!location.pathname.includes("admin") && (
        <div id="whatsapp-icon" className="whatsapp">
          <a href="https://wa.me/+5491154118520" target={"_blank"}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/240px-WhatsApp.svg.png"
              width="50"
              height="50"
            />
          </a>
        </div>
      )}
    </>
  );
};

export default WhatsappWidget;
